import React from "react";
const IconRadioSelected = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <rect x="2" y="2" width="16" height="16" rx="8" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <circle cx="10" cy="10" r="4" fill="currentColor" />
  </svg>
);
export default IconRadioSelected;
